import { render, staticRenderFns } from "./entruckAdd.vue?vue&type=template&id=c0bdbfaa&scoped=true&"
import script from "./entruckAdd.vue?vue&type=script&lang=js&"
export * from "./entruckAdd.vue?vue&type=script&lang=js&"
import style0 from "./entruckAdd.vue?vue&type=style&index=0&id=c0bdbfaa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0bdbfaa",
  null
  
)

export default component.exports